/**
 * Created by hieult on 11/14/17.
 */
import * as types from '../constants/actionTypes';
import initialState from './initialState';
import * as constants from '../constants/constants';
import Immutable from 'seamless-immutable';

export default function friendsAndFavoritesReducer(state = initialState.friendsAndFavorites, action) {
  switch (action.type) {
    case types.GET_FRIENDS_FAVORITES: {
      const { isNotUpdateWhenNoData, data } = action;
      state = state.set('isAPIDataLoaded', true);
      state = state.set('isError', false);
      state = state.set('isLoading', false);
      if (isNotUpdateWhenNoData && data.length === 0) {
        return state;
      }

      if (data.length >= 0) {
        state = state.set(
          'displayData',
          data.filter((item, index) => index < constants.PAGING_DEFAULT.PAGE_SIZE_FRIEND)
        );
      }
      return state.set('data', data);
    }
    case types.UPDATE_TEMP_DISPLAY_DATA_FRIEND_AND_FAV_SUCCESS:
      return state.set('tempDisplayData', state.data).set('tempFilterIndex', state.tempFilterIndex);
    // eslint-disable-next-line no-case-declarations
    case types.UPDATE_TEMP_DATA_FRIEND_AND_FAV_TO_DISPLAY_SUCCESS:
      const { tempDisplayData } = Immutable.asMutable(state);
      const data = tempDisplayData;
      if (data && data.length >= 0) {
        state = state.set(
          'displayData',
          data.filter((item, index) => index < constants.PAGING_DEFAULT.PAGE_SIZE_FRIEND)
        );
      }
      return state.set('data', state.tempDisplayData).set('filterIndex', state.tempFilterIndex);
    case types.GET_FRIENDS_FAVORITES_REQUEST:
      return state.set('isLoading', true);
    case types.GET_FRIENDS_FAVORITES_FAILURE:
      return state.set('isError', true).set('isLoading', false);
    case types.UPDATE_FILTER_FRIEND_AND_FAVORITE: {
      const filterIndex = action.data;
      // let allData = action.data === constants.FRIENDS_FAVOURITES_FILTER_OPTION.ALL
      //   ? state.data
      //   : (action.data === constants.FRIENDS_FAVOURITES_FILTER_OPTION.ACTIVE ? state.data.filter(item => item.online)
      //   : state.data.filter(item => item.isMatch)) ;
      const displayData = getFriendByPaging(0, state.data);

      state = state.set('pageNumber', 0);
      state = state.set('filterIndex', filterIndex);
      state = state.set('canPaging', displayData.length < state.data);
      return state.set('displayData', displayData);
    }

    case types.BLOCK_USER: {
      const data = state.data.asMutable() || [];
      const updatedData = data.filter(x => x.userId.toString() !== action.data.toString());
      const { pageNumber } = state;
      const displayData = getFriendByPaging(pageNumber, updatedData);
      state = state.set('displayData', displayData);
      return state.set('data', updatedData);
    }

    case types.LOAD_MORE_FRIENDS_FAVORITES: {
      if (!state.data || !state.data.length) {
        return { ...state };
      }

      const pageNumber = state.pageNumber + 1;
      let allData = state.data;
      if (state.filterIndex !== constants.FRIENDS_FAVOURITES_FILTER_OPTION.ALL) {
        allData =
          state.filterIndex === constants.FRIENDS_FAVOURITES_FILTER_OPTION.ACTIVE
            ? state.data.filter(item => item.online)
            : state.data.filter(item => item.isMatch);
      }
      const displayData = getFriendByPaging(pageNumber, allData);

      state = state.set('pageNumber', pageNumber);
      state = state.set('canPaging', displayData.length < allData.length);
      return state.set('displayData', displayData);
    }

    case types.ADD_FAVORITE: {
      const data = state.data.asMutable() || [];
      const updatedData = data.concat(action.data);
      const { pageNumber } = state;
      const allData = state.filterIndex === constants.FRIENDS_FAVOURITES_FILTER_OPTION.ALL ? updatedData : updatedData.filter(item => item.online);
      const displayData = getFriendByPaging(pageNumber, allData);
      state = state.set('displayData', displayData);
      return state.set('data', updatedData);
    }

    case types.REMOVE_FAVORITE: {
      const data = state.data.asMutable() || [];
      const profiles = action.data;
      const updatedData = data.filter(item => {
        const profile = profiles.filter(e => e === item.userId);
        return !(profile && profile.length > 0);
      });
      const { pageNumber } = state;
      const allData = state.filterIndex === constants.FRIENDS_FAVOURITES_FILTER_OPTION.ALL ? updatedData : updatedData.filter(item => item.online);
      const displayData = getFriendByPaging(pageNumber, allData);
      state = state.set('displayData', displayData);
      return state.set('data', updatedData);
    }
    case types.USER_LOGOUT_SUCCESS: {
      state = initialState.friendsAndFavorites;
      return state;
    }

    default:
      return state;
  }
}

function getFriendByPaging(pageNumber, data) {
  const numberItemNeedGet = pageNumber ? pageNumber * constants.PAGING_DEFAULT.PAGE_SIZE_FRIEND : constants.PAGING_DEFAULT.PAGE_SIZE_FRIEND;
  return data.filter((item, index) => index < numberItemNeedGet);
}
